export const IconCube = () => (
  <svg
    width='10'
    height='11'
    viewBox='0 0 10 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.5' width='10' height='10' fill='#444ce7' />
  </svg>
);
